import React from "react";
import { FaTimes, FaMagic } from "react-icons/fa";

const ImageQualityModal = ({
  isOpen,
  onClose,
  imageQuality,
  setImageQuality,
  isFreeModel,
  isPreview = false,
  className = ""
}) => {
  if (!isOpen && !isPreview) return null;
  const options = [
    { id: '2K', label: '2K (upto 2086px)' },
    { id: '4K', label: '4K (upto 4096px)' }
  ];

  const Panel = (
    <div className="glass-effect rounded-2xl border border-white/10 bg-[#111111]/95 backdrop-blur-2xl p-4 w-72 sm:w-80">
      <div className="flex items-center gap-2 mb-2">
        <FaMagic className="text-purple-300/90 text-xs" />
        <h3 className="text-xs font-medium text-white">Image quality</h3>
        {!isPreview && (
          <button type="button" className="ml-auto text-gray-300 hover:text-white" onClick={onClose}>
            <FaTimes className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {options.map(q => (
          <button
            key={q.id}
            type="button"
            disabled={isFreeModel}
            className={`px-2 py-1 rounded-full border text-[11px] ${imageQuality === q.id ? 'bg-white/10 text-white border-white/20' : 'text-gray-300 border-gray-600/40'} ${isFreeModel ? 'opacity-50 cursor-not-allowed' : ''}`}
            onClick={() => { if (!isFreeModel) { setImageQuality(q.id); if (!isPreview) onClose(); } }}
            title={q.label}
          >
            {q.label}
          </button>
        ))}
      </div>
    </div>
  );

  if (isPreview) return <div className={`absolute z-50 pointer-events-auto ${className}`}>{Panel}</div>;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      {Panel}
    </div>
  );
};

export default ImageQualityModal; 